import { memo, ReactElement, ReactNode, useMemo } from 'react';
import { ListCell } from '@cbhq/cds-web/cells/ListCell';
import { Box } from '@cbhq/cds-web/layout';
import { TextHeadline } from '@cbhq/cds-web/typography';

import { RemoteImage } from '../../NavigationLink/components/RemoteImage/RemoteImage';

type ActionItemProps = {
  label: string;
  description?: string;
  imageUrl?: string;
  icon: ReactElement;
  onPress: () => void;
  negative?: boolean;
  end?: ReactNode;
  testID?: string;
};

export const ActionItem = memo(
  ({ label, icon, negative, onPress, end, testID, imageUrl, description }: ActionItemProps) => {
    const titleLabel = useMemo(() => {
      return (
        <TextHeadline as="p" color={negative ? 'fgNegative' : undefined} display="block">
          {label}
        </TextHeadline>
      );
    }, [label, negative]);

    const media = useMemo(() => {
      if (imageUrl) {
        return (
          <RemoteImage source={imageUrl} shape="circle" resizeMode="cover" width={32} height={32} />
        );
      }
      return (
        <Box width={32} height={32} justifyContent="center" alignItems="center">
          {icon}
        </Box>
      );
    }, [imageUrl, icon]);

    return (
      <ListCell
        media={media}
        title={titleLabel}
        description={description}
        compact
        onClick={onPress}
        action={end}
        variant={negative ? 'negative' : undefined}
        testID={testID}
      />
    );
  },
);
